import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { SpacingSetting, spacingSettingAtom, themeAtom, Themes } from '@js/store/settingsAtoms';
import { useAtomValue } from 'jotai';

interface Props {
    children: ReactNode;
}

const ThemeProvider: FC<Props> = ({ children }) => {
    const theme = useAtomValue(themeAtom);
    const spacingSetting = useAtomValue(spacingSettingAtom);

    return (
        <div
            id="theme"
            className={classNames('theme', {
                themeLight: theme === Themes.Light,
                themeDark: theme === Themes.Dark,
                themeAuto: theme === Themes.Auto,
                spacingCompact: spacingSetting === SpacingSetting.Compact,
            })}
        >
            {children}
        </div>
    );
};

export default ThemeProvider;
